var _defs, _circle, _circle2, _circle3, _path, _path2, _line, _line2, _circle4, _circle5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg8ChBig(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 250,
    x2: 250,
    y2: 500,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "8 Channel_Big") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    fill: "#5472ea"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 250,
    r: 250,
    opacity: 0.1,
    fill: "url(#linear-gradient)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 91.28,
    cy: 250,
    r: 35.89,
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 10
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M86.49,239.82s78.19-77.76,88.14-87.71,20.89-14,31.5-14h187",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.11,260.18s78.19,77.76,88.14,87.71,20.89,14,31.49,14h187",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 30
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 210,
    x2: 290,
    y2: 290,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 210,
    y1: 290,
    x2: 290,
    y2: 210,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.71,
    cy: 208.16,
    r: 28.16,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 395.71,
    cy: 278.48,
    r: 41.52,
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg8ChBig);
export default __webpack_public_path__ + "static/media/8Ch_Big.0d6d21ccbb9b5f08eed578488fe7b3e2.svg";
export { ForwardRef as ReactComponent };